/* nono-basket.js – 8 Oct 2026 basket review. Vanilla, no deps.
   1) Sticky Add to basket bar on PDPs (mobile). 2) "Add" buttons for drawer pairings (re-renders the Dawn cart drawer). */
(() => {
  const money = (c) => '£' + (c / 100).toFixed(2);
  const inBasket = (c) => c - Math.floor((c * 20) / 100); // Shopify floors the 20% to the penny

  /* ---------- 1. sticky ATC ---------- */
  document.querySelectorAll('.nono-satc').forEach((bar) => {
    const form = document.getElementById(bar.dataset.formId);
    if (!form) return;
    const real = form.querySelector('[name="add"]');
    const btn = bar.querySelector('.nono-satc__btn');
    const sizeEl = bar.querySelector('.nono-satc__size');
    const priceEl = bar.querySelector('.nono-satc__price');
    const auto20 = bar.dataset.auto20 === 'true';
    const mq = matchMedia('(max-width: 749px)');
    let past = false;

    const sync = () => {
      const show = mq.matches && past;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      btn.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('nono-satc-on', show);
    };
    // Scroll check (rAF-throttled) rather than IntersectionObserver: IO skips the change when a jump
    // goes straight from "below the fold" to "above the top" (both non-intersecting).
    if (real) {
      let ticking = false;
      const check = () => {
        ticking = false;
        const r = real.getBoundingClientRect();
        const now = r.bottom < 0 && r.height > 0;
        if (now !== past) { past = now; sync(); }
      };
      const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(check); } };
      addEventListener('scroll', onScroll, { passive: true });
      addEventListener('resize', onScroll, { passive: true });
      check();
    }
    mq.addEventListener('change', sync);

    const syncButton = () => {
      if (!real) return;
      btn.disabled = real.disabled;
      const label = real.querySelector('span');
      if (label) btn.textContent = label.textContent.trim();
    };
    if (real) new MutationObserver(syncButton).observe(real, { attributes: true, childList: true, subtree: true });

    btn.addEventListener('click', () => {
      if (btn.disabled) return;
      if (form.requestSubmit) form.requestSubmit(real || undefined);
      else if (real) real.click();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { // const globals aren't on window
      subscribe(PUB_SUB_EVENTS.variantChange, (ev) => {
        const d = ev && ev.data;
        if (!d || d.sectionId !== bar.dataset.sectionId || !d.variant) return;
        const v = d.variant;
        if (sizeEl) sizeEl.textContent = (v.title || '').split(' - ')[0];
        if (priceEl) {
          // 2026-10-09 plain sale: struck base price + sale price (same markup as snippets/nono-sale-price.liquid)
          priceEl.innerHTML = auto20 && v.price > 0
            ? '<span class="nono-sp nono-sp--sale"><span class="visually-hidden">Regular price</span><s class="nono-sp__was">' + money(v.price) + '</s> <span class="visually-hidden">Sale price</span><span class="nono-sp__now">' + money(inBasket(v.price)) + '</span></span>'
            : '<span class="nono-sp">' + money(v.price) + '</span>';
        }
        syncButton();
      });
    }
  });

  /* ---------- 2. drawer pairing "Add" ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-nono-pair-add]');
    if (!b) return;
    e.preventDefault();
    const drawer = document.querySelector('cart-drawer');
    b.setAttribute('aria-busy', 'true');
    b.disabled = true;
    fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(b.dataset.nonoPairAdd), quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    })
      .then((r) => r.json())
      .then((state) => {
        if (state.status) throw new Error(state.description || state.message);
        if (drawer && drawer.renderContents) {
          state.id = Number(b.dataset.nonoPairAdd);
          drawer.renderContents(state);
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(() => {
        b.disabled = false;
        b.removeAttribute('aria-busy');
        const err = document.getElementById('CartDrawer-CartErrors');
        if (err) err.textContent = (window.cartStrings && window.cartStrings.error) || "Sorry, that didn't update. Please try again.";
      });
  });
})();
